module.exports = {
    Accounting: 'accounting',
    Invoicing: 'invoicing',
    ShineInvoicingAccounting: 'shine_invoicing_accounting',
    SupernavInvoicingAccounting: 'supernav_invoicing_accounting'
}
